/* 场馆信息相关接口 */
import path from '@/api/index'
import {
  axios
} from '@/utils/request'
import parsePageParams from '@/utils/page'

// 分页
export function queryList (data) {
  return axios({
    url: path.mobile + '/serviceInfo',
    method: 'POST',
    data: data,
    params: parsePageParams(data)
  })
}
